import React, { useContext, useState, useEffect } from 'react';

import { Field } from 'formik'
import { TextField } from 'formik-material-ui';
import { Switch } from '../../../../common/formik';

import {
    Grid,
    Card,
    CardContent,
    CardHeader,
    Divider,
    InputAdornment,
    Button,
    CircularProgress,
    colors
} from '@material-ui/core';

import { 
    Select,
    FieldError
} from '../../../../common';

import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';

import { LocalTableNames, SapTableNames } from '../../../../../helpers';

import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

import { makeStyles } from '@material-ui/core/styles';
import { DbType } from '../../../../../helpers/Common';
const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
    loader: {
        color: "black"
    },
    sapOk: {
        color: colors.green[500]
    },
    sapError: {
        color: colors.red[500]
    }
}));

export const ExtraInfoForm = (props) => {
    const classes: any = useStyles();
    
    const {        
        state,
        getTableOptions,
        getTableOptionsWithNumber,
        validateSapCode
    } = useContext(CustomerRequestContext)

    const { 
        values,
        isSavingRequest,
        setFieldValue
    } = useContext(TabsContext);


    const [isValidatingSapCode, setIsValidatingSapCode] = useState(false);
    const [isSapCodeOk, setIsSapCodeOk] = useState(null);
    const checkSapCodeClickHandler = async () => {        
        const sapCode = values.customerSapCode;
        
        if (sapCode){
            setIsValidatingSapCode(true);
            setIsSapCodeOk(null);
            const isValid = await validateSapCode(sapCode, values.dbType);
            setIsSapCodeOk(isValid);
            setIsValidatingSapCode(false);
        }
    }

    return (
        <Card className={classes.card}>
            <CardHeader title="Extra information" />
            <CardContent>
                <Grid container spacing={3}>
                    {
                        state.request.dbType === DbType.ECC &&
                        <>
                            <Grid item xs={12}>
                                <Select
                                    name="principalOperationCountryId"
                                    label="Principal operating country *"   
                                    disabled={props.disabled}
                                    options={getTableOptions(LocalTableNames.PrincipalOperationCountries, values.dbType, null, true)}
                                />
                                <FieldError name="principalOperationCountryId" errors={state.errors} />
                            </Grid>
                            <Divider style={{ width: "100%" }} />
                        </>
                    }
                    <Grid item xs={12}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Field
                                    label="Does the new customer already exist?"
                                    name="isExistingCustomer"
                                    disabled={values.dbType === DbType.S4 || isSavingRequest || props.disabled}
                                    component={Switch} 
                                />                            
                                <FieldError name="isExistingCustomer" errors={state.errors} />
                            </Grid>
                            {values.isExistingCustomer && (                            
                                <Grid item xs={12}>
                                    <Field
                                        className={classes.field}
                                        variant="outlined"
                                        type="text"
                                        name="customerSapCode"
                                        label="Customer SAP code *"
                                        disabled={props.disabled}
                                        component={TextField}
                                        InputProps={{
                                            endAdornment:
                                                <InputAdornment position="end">
                                                    <Button
                                                        startIcon={isValidatingSapCode ?
                                                            <CircularProgress size={20} className={classes.loader} />
                                                            :
                                                            <>
                                                                {isSapCodeOk === null ? 
                                                                    ""
                                                                    :
                                                                    isSapCodeOk === true ? <CheckIcon className={classes.sapOk} /> : <CloseIcon className={classes.sapError}/>
                                                                }
                                                            </>
                                                        }
                                                        disabled={props.disabled}
                                                        onClick={checkSapCodeClickHandler}>
                                                        Check
                                                    </Button>                                                   
                                                </InputAdornment>                        
                                        }}                                        
                                    />
                                    <FieldError name="customerSapCode" errors={state.errors} />
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                    <Divider style={{ width: "100%" }} />
                    <Grid item xs={12}>
                        <Field
                            name="parentBeneficialOwner"
                            type="text"
                            style={{ width: "100%" }}
                            variant="outlined"
                            label="Parent/Beneficial Owner"
                            disabled={props.disabled}
                            component={TextField} 
                        />
                        <FieldError name="parentBeneficialOwner" errors={state.errors} />
                    </Grid>
                    <Divider style={{ width: "100%" }} />
                    <Grid item xs={12}>
                        <Field
                            name="affiliates"
                            type="text"
                            style={{ width: "100%" }}
                            variant="outlined"
                            label="Affiliates"
                            disabled={props.disabled}
                            component={TextField} 
                        />
                        <FieldError name="affiliates" errors={state.errors} />
                    </Grid>
                    <Divider style={{ width: "100%" }} />
                    <Grid item xs={12}>
                        <Select
                            name="chainId"
                            label="Chain *"
                            disabled={props.disabled}
                            options={getTableOptionsWithNumber(SapTableNames.Chains, values.dbType)}
                        />
                        <FieldError name="chainId" errors={state.errors} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}